import React__default from 'react';
import { Alert, Link, Card } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import CategoryGroup from '../../../CategoryGroup/CategoryGroup.js';
import { useRecentOrders } from '../../hooks/use-recent-orders.js';
import { LoadingData } from '../LoadingData.js';
import { logOrderEvent } from '../../../data-layer/orders.js';
import { makeOrderDetailsClickEvent } from '../../../data-layer/utils.js';

const RecentOrders = ()=>{
    const { data , hasRecentOrders , loading , error  } = useRecentOrders();
    const { getLabel , getFormattedLabel  } = useIntl();
    var ref;
    const { href: ordersRoute , onClick  } = (ref = useLink({
        route: 'me.orders'
    })) !== null && ref !== void 0 ? ref : {};
    const onViewRecentOrdersClick = (e)=>{
        logOrderEvent({
            event_type: 'my_account',
            event: 'my_online_orders_click',
            order: {
                button: 'View all orders'
            }
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    if (loading) {
        return /*#__PURE__*/ React__default.createElement(LoadingData, null);
    }
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "recent-orders__container"
    }, /*#__PURE__*/ React__default.createElement(Text, null, hasRecentOrders || error ? getLabel('account.profile.recentOrders.description') : getFormattedLabel('account.profile.recentOrders.noOrders')), hasRecentOrders ? /*#__PURE__*/ React__default.createElement("div", {
        className: "recent-orders__list"
    }, data === null || data === void 0 ? void 0 : data.map(({ orderNumber , orderDate , orderImageUrl , orderImageAlt , paymentStatus  })=>/*#__PURE__*/ React__default.createElement(RecentOrder, {
            key: orderNumber,
            orderNumber: orderNumber,
            orderDate: orderDate,
            orderImageUrl: orderImageUrl,
            orderImageAlt: orderImageAlt,
            paymentStatus: paymentStatus
        })
    )) : /*#__PURE__*/ React__default.createElement(CategoryGroup, null), error && /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        notifyScreenReader: false
    }, getFormattedLabel('account.profile.recentOrders.error', {
        parseLink: true,
        parseHTML: true
    })), hasRecentOrders || error ? /*#__PURE__*/ React__default.createElement(Link, {
        href: ordersRoute,
        onClick: onViewRecentOrdersClick,
        iconAfter: "chevron-right"
    }, getLabel('account.profile.recentOrders.link')) : null);
};
const RecentOrder = ({ orderNumber , orderDate , orderImageUrl , orderImageAlt , paymentStatus  })=>{
    var ref;
    const { href: ordersDetailRoute , onClick  } = (ref = useLink({
        route: 'me.orders.detail',
        params: {
            orderId: orderNumber
        }
    })) !== null && ref !== void 0 ? ref : {};
    const { dateTime , getFormattedLabel  } = useIntl();
    const cardAriaLabel = getFormattedLabel('account.profile.recentOrders.orderLink', {
        labelData: {
            orderNumber
        }
    });
    const handleOnClick = (e)=>{
        logOrderEvent(makeOrderDetailsClickEvent('my_account', orderNumber, paymentStatus));
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ React__default.createElement(Card, {
        key: orderNumber,
        href: ordersDetailRoute,
        onClick: handleOnClick,
        "aria-label": cardAriaLabel,
        className: "recent-orders__card-link"
    }, /*#__PURE__*/ React__default.createElement(Card.Image, {
        alt: orderImageAlt,
        src: orderImageUrl,
        backgroundColor: "var(--color--shade-lightest)",
        className: "recent-orders__card-image"
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "recent-orders__card-content-wrapper"
    }, /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Text, {
        className: "recent-orders__card-order-date"
    }, dateTime.formatShortDate(new Date(orderDate))), /*#__PURE__*/ React__default.createElement(Card.Heading, null, getFormattedLabel('account.profile.recentOrders.orderTitle', {
        labelData: {
            orderNumber
        }
    }))), /*#__PURE__*/ React__default.createElement(Card.Icon, {
        name: "chevron-right",
        className: "recent-orders__card-content-chevron"
    })));
};
var RecentOrders$1 = RecentOrders;

export { RecentOrders$1 as default };
//# sourceMappingURL=RecentOrders.js.map
